import axios from "axios";
import { apiAddress } from "../../config/server";
import { ImportType } from "../../types/imports/ImportType";
import { IImport } from "../../types/imports/import";
import ImportsApi from "../api/importsApi";
import * as types from "./actionTypes";

const ImportApiBase = `${apiAddress}/api/import/`;

export function importUploadStarted() {
  return { type: types.IMPORT_UPLOAD_STARTED };
}
export function importUploadProgress(progress: number) {
  return { type: types.IMPORT_UPLOAD_PROGRESS, payload: progress };
}
export function importUploadFulfilled(asset: IImport) {
  return { type: types.IMPORT_UPLOAD_FULFILLED, payload: asset };
}
export function importUploadRejected(error: any) {
  return { type: types.IMPORT_UPLOAD_REJECTED, error: error.message };
}

export function importTriggerStarted() {
  return { type: types.IMPORT_TRIGGER_STARTED };
}
export function importTriggerFulfilled(imp: IImport) {
  return { type: types.IMPORT_TRIGGER_FULFILLED, payload: imp };
}
export function importTriggerRejected(importId: string, error: Error) {
  return {
    type: types.IMPORT_TRIGGER_REJECTED,
    payload: importId,
    error: error.message,
  };
}

export function getMyImportsStarted() {
  return { type: types.IMPORT_GET_MY_STARTED };
}
export function getMyImportsFulfilled(imports: any) {
  return { type: types.IMPORT_GET_MY_FULFILLED, payload: imports };
}
export function getMyImportsRejected(error: any) {
  return {
    type: types.IMPORT_GET_MY_REJECTED,
    error: error.message,
    stack: error.stack,
  };
}

export function getImportStarted(importId: string) {
  return { type: types.IMPORT_GET_STARTED, payload: importId };
}
export function getImportFulfilled(importJob: any) {
  return { type: types.IMPORT_GET_FULFILLED, payload: importJob };
}
export function getImportRejected(importId: string, error: any) {
  return {
    type: types.IMPORT_GET_REJECTED,
    payload: { importId, error: error.message, stack: error.stack },
  };
}

// export function uploadFile(file) {
//   return (dispatch) => {
//     dispatch(importUploadStarted());
//     ImportApi.
//   }
// }

export function queueImport(
  file: any,
  options: { importType: ImportType, associationId: string | null, importOldGames: boolean },
  uploadProgress: any,
) {
  return (dispatch: any) => {
    dispatch(importUploadStarted());
    return ImportsApi.queueImport(
      file,
      options,
      uploadProgress,
    ).then((imp) => {
      dispatch(importUploadFulfilled(imp));
      return imp;
    });
    // .catch(er => dispatch(importUploadRejected(er)))
  };
}

export function triggerImport(importId: string, mapping: object | null) {
  return (dispatch: any) => {
    dispatch(importTriggerStarted());
    return ImportsApi.triggerImport(importId, mapping)
      .then((imp) => {
        dispatch(importTriggerFulfilled(imp));
        return imp;
      })
      .catch((er) => {
        dispatch(importTriggerRejected(importId, er));
        throw er;
      });
  };
}

export function getMyImports() {
  return (dispatch: any) => {
    dispatch(getMyImportsStarted());

    return axios
      .get(ImportApiBase)
      .then((response) => {
        if (response.data && response.data.success)
          return dispatch(getMyImportsFulfilled(response.data.data));
        return dispatch(
          getMyImportsRejected(new Error("An unknown error occurred")),
        );
      })
      .catch((er) => {
        dispatch(getMyImportsRejected(er));
      });
  };
}

export function getImport(importId: string) {
  return (dispatch: any) => {
    dispatch(getImportStarted(importId));

    return axios
      .get(ImportApiBase + importId)
      .then((resp) => {
        if (resp.data.data) dispatch(getImportFulfilled(resp.data.data));
        else throw new Error(resp.data.message);
      })
      .catch((er) => {
        dispatch(getImportRejected(importId, er));
        throw er;
      });
  };
}
